var $ = jQuery;

var settings = { copyWithHashtag: false }; function parseColorValues(colorValues) {
    var colorValuesArray = colorValues.match(/\b[0-9A-Fa-f]{3}\b|[0-9A-Fa-f]{6}\b/g); if (colorValuesArray) {
        colorValuesArray = colorValuesArray.map(function (item) {
            if (item.length === 3) { var newItem = item.toString().split(''); newItem = newItem.reduce(function (acc, it) { return acc + it + it; }, ''); return newItem; }
            return item;
        });
    }
    return colorValuesArray;
}
function pad(number, length) {
    var str = '' + number; while (str.length < length) { str = '0' + str; }
    return str;
}
function hexToRGB(colorValue) { return { red: parseInt(colorValue.substr(0, 2), 16), green: parseInt(colorValue.substr(2, 2), 16), blue: parseInt(colorValue.substr(4, 2), 16) } }
function intToHex(rgbint) { return pad(Math.min(Math.max(Math.round(rgbint), 0), 255).toString(16), 2); }
function rgbToHex(rgb) { return intToHex(rgb.red) + intToHex(rgb.green) + intToHex(rgb.blue); }
function rgbShade(rgb, i) { return { red: rgb.red * (1 - 0.1 * i), green: rgb.green * (1 - 0.1 * i), blue: rgb.blue * (1 - 0.1 * i) } }
function rgbTint(rgb, i) { return { red: rgb.red + (255 - rgb.red) * i * 0.1, green: rgb.green + (255 - rgb.green) * i * 0.1, blue: rgb.blue + (255 - rgb.blue) * i * 0.1 } }
function calculate(colorValue, shadeOrTint) {
    var color = hexToRGB(colorValue); var shadeValues = []; for (var i = 0; i < 10; i++) { shadeValues[i] = rgbToHex(shadeOrTint(color, i)); }
    return shadeValues;
}
function calculateShades(colorValue) { return calculate(colorValue, rgbShade).concat("000000"); }
function calculateTints(colorValue) { return calculate(colorValue, rgbTint).concat("ffffff"); }
function updateClipboardData() { var colorCells = $("#tints-and-shades td[data-clipboard-text]"); $.each(colorCells, function (i, cell) { var colorCode = $(cell).attr("data-clipboard-text"); if (settings.copyWithHashtag) { $(cell).attr("data-clipboard-text", "#" + colorCode); } else { $(cell).attr("data-clipboard-text", colorCode.substr(1)); } }); }
function makeTableRowColors(colors, displayType) {
    var tableRow = "<tr>"; for (var i = 0; i < colors.length; i++) { var color = colors[i].toString(16); if (displayType == "colors") { var colorPrefix = settings.copyWithHashtag ? "#" : ""; tableRow += "<td tabindex=\"0\" role=\"button\" aria-label=\"Color swatch\" class=\"hex-color\" style=\"background-color:" + "#" + color + "\" data-clipboard-text=\"" + colorPrefix + color + "\"></td>"; } else { tableRow += "<td class=\"hex-value\">" + color.toUpperCase() + "</td>"; } }
    tableRow += "</tr>"; return tableRow;
}

function createTintsAndShades(firstTime) {

    var parsedColorsArray = parseColorValues($("#color-values").val()); 
    
        if (parsedColorsArray !== null) {
        var colorDisplayRows = []; 
        var tableRowCounter = 0; 

        for (var i = 0; i < parsedColorsArray.length; i++) { 
            var calculatedShades = calculateShades(parsedColorsArray[i]); 
            colorDisplayRows[tableRowCounter] = makeTableRowColors(calculatedShades, "colors"); 
            tableRowCounter++; 
            colorDisplayRows[tableRowCounter] = makeTableRowColors(calculatedShades, "RGBValues"); 
            tableRowCounter++; 
            var calculatedTints = calculateTints(parsedColorsArray[i]); 
            colorDisplayRows[tableRowCounter] = makeTableRowColors(calculatedTints, "colors"); 
            tableRowCounter++; 
            colorDisplayRows[tableRowCounter] = makeTableRowColors(calculatedTints, "RGBValues"); 
            tableRowCounter++; 
        }

    var colorDisplayTable = "<table><thead><tr class=\"table-header\"><td><span>0%</span></td><td><span>10%</span></td><td><span>20%</span></td><td><span>30%</span></td><td><span>40%</span></td><td><span>50%</span></td><td><span>60%</span></td><td><span>70%</span></td><td><span>80%</span></td><td><span>90%</span></td><td><span>100%</span></td></tr></thead>" + colorDisplayRows.join("") + "</table>";
        $("#tints-and-shades").html(colorDisplayTable); 

        var bodyClass = $("body").attr('class');

        if(bodyClass !== 'single-colors'){
            window.location.hash = parsedColorsArray.join(","); 
        }

        $('html,body').animate({ scrollTop: $("#ts-scroll-top").offset().top }, 400); 
        setTimeout(function () { $("#tints-and-shades").attr("tabindex", "0");
        $("#tints-and-shades").focus(); }, 400); 
        $("#tints-and-shades").blur(function () { 
            $("#tints-and-shades").attr("tabindex", "-1"); 
        })
    } else if (firstTime != true) { 
        $('html,body').stop().animate({ scrollTop: 0 }, 200, function () { $("#tints-and-shades").html(""); window.location.hash = ""; 
        $("#warning").addClass("visible"); 
        setTimeout(function () { $("#warning").removeClass("visible"); }, 3000); }); 
        $("#color-values").focus(); 
    }
    return false;
}

$(document).ready(function () {

   
    var bodyClass = $("body").attr('class');

    if(bodyClass !== 'single-colors'){
        $("#color-values").val(window.location.hash.slice(1).replace(/,/g, " "));
    }

    createTintsAndShades(true);

        $("#color-entry-form").submit(createTintsAndShades);
            $("#copy-with-hashtag").on("click", function (e) {
                settings.copyWithHashtag = e.target.checked; updateClipboardData();
            }
        );
    }

);
    $(document).keypress(function (event) {
        if ((event.keyCode ? event.keyCode : event.which) == "13") $(":focus").click();
    }
);
